import React from "react"
import { Layout, Row, Col, Icon } from 'antd';
const { Footer, Content } = Layout;
const dt = new Date();



export const FooterApp = React.memo(() => {
    return (
        <Footer className="footer-container">
            <Row align="middle" justify="center" type="flex" className="footer-container-item footer-container-copyright">
                <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                    <p>Copyright © {dt.getFullYear()} Teknomaint Sistemi Informatici S.r.l.</p>
                    <p>Reg. Impr. Pr P.Iva 02391490345 | Capitale Sociale € 25.000 i.v.</p>
                </Col>
                <Col xs={24} sm={24} md={6} lg={6} xl={6} className="text-right">
                    <a href={'https://www.facebook.com/TeknomaintParma/'} rel="noopener noreferrer" target="_blank" title="Facebook" data-label="Facebook"><Icon type="facebook" style={{ fontSize: 30, marginRight: 20 }} /></a>
                    <a href={'https://www.linkedin.com/company/teknomaint-sistemi-informatici-srl'} rel="noopener noreferrer" target="_blank" title="Linkedin" data-label="Linkedin"><Icon type="linkedin" style={{ fontSize: 30 }} /></a>
                </Col>
            </Row>
        </Footer>
    )
})
